import { NavLink } from 'react-router-dom';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { type MenuItem } from '@/types/common';
import IcPlus from '@/assets/icons/Plus.svg?react';
import NavGroup from './NavGroup';
import NavigationLink from './NavigationLink';
import styles from './Navigation.module.scss';

interface NavigationProps {
  className?: string;
  menuItems: MenuItem[];
}

const Navigation = ({ className, menuItems }: NavigationProps) => {
  const { t } = useTranslation(['common']);

  return (
    <nav className={classNames(styles.navigation, className)}>
      <NavLink to="/signings/new" className={styles.new}>
        <IcPlus className={styles.newIcon} />
        <span className={styles.newLabel}>
          {t('common:menu.newSigningButton')}
        </span>
      </NavLink>
      <div className={styles.items}>
        {menuItems.map((item) =>
          item.submenuItems?.length ? (
            <NavGroup
              key={item.label + item.href}
              className={styles.group}
              item={item}
            />
          ) : (
            <NavigationLink
              key={item.label + item.href}
              action={item.action}
              highlight={item.highlight}
              href={item.href}
              Icon={item.icon}
              label={item.label}
              refreshOnSameClick={item.refreshOnSameClick}
              target={item.target}
            />
          )
        )}
      </div>
    </nav>
  );
};

export default Navigation;
